export const loadScript = async (src: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[src="' + src + '"]')) {
      return resolve('duplicated');
    }

    const element = document.createElement('script');

    element.type = 'text/javascript';
    element.async = true;
    element.src = src;

    element.addEventListener('load', resolve);
    element.addEventListener('error', reject);
    element.addEventListener('abort', reject);

    document.head.appendChild(element);
  });
};
